import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

export const useGetScheduleQualityTrend = (params: QueryParams, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getScheduleQualityTrend', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.latestVersionId) && Boolean(params.contractId) && Boolean(params.compareVersionId),
    });
};

export interface QueryParams extends NarrativeRequest {
    compareVersionId: number | undefined;
    contractId: number | null | undefined;
    latestVersionId: number | undefined;
    filter: any;
}

export type QueryResponse = [
    {
        name: string;
        graphPoints: GraphPoint[];
    },
];

export interface GraphPoint {
    versionName: string;
    versionDate: number;
    score: number;
    status: string;
    versionHashCode: number;
}
